import { DEFAULT_ANIMATE_DURATION, noForwardProps } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import ParagraphBlockLinkButton from '@src/components/battle/demo/blocks/ParagraphBlockLinkButton'
import { ParagraphBlockVariant } from '@src/constants/pageBuilder'
import { ParagraphBlock } from '@src/types/pageBuilder'
import { Trans } from 'react-i18next'

type Props = {
  href?: string
  layoutProps: ParagraphBlock['layoutProps']
  text: string
  variant?: ParagraphBlock['variant']
}

const Container = styled(Box, noForwardProps)<{
  __marginTop?: number
  __paddingLeft?: number
  __variant: ParagraphBlock['variant']
}>`
  display: flex;
  margin-top: ${({ __marginTop }) => __marginTop}px;
  width: 100%;
  transition: filter ${DEFAULT_ANIMATE_DURATION}ms,
    transform ${DEFAULT_ANIMATE_DURATION}ms;

  :hover {
    filter: brightness(1.1);
    transform: translateY(-3px);
  }

  ${({ __variant }) => {
    if (__variant === ParagraphBlockVariant.InfoBlock) {
      return `
        background: rgba(255, 255, 255, 0.10);
        padding: 16px;
        border-radius: 4px;
      `
    } else if (__variant === ParagraphBlockVariant.BlueBlock) {
      return `
        border-radius: 4px;
        border: 3px solid rgba(255, 255, 255, 0.20);
        background: #232838;
        padding: 16px;
        width: fit-content;
      `
    }
  }}
  ${({ __paddingLeft }) => __paddingLeft ?? `padding-left: ${__paddingLeft}px;`}
`

const TextBlock = styled(Typography)`
  flex: 1;
  white-space: pre-wrap;
`

const ParagraphBlockView = ({ href, layoutProps, text, variant }: Props) => {
  return (
    <Container
      __variant={variant}
      __marginTop={layoutProps.marginTop}
      __paddingLeft={layoutProps.paddingLeft}
    >
      <TextBlock>
        <Trans
          components={{
            strong: <strong />,
            br: <br />
          }}
        >
          {text}
        </Trans>
      </TextBlock>
      <ParagraphBlockLinkButton href={href} />
    </Container>
  )
}

export default ParagraphBlockView
